export default {
  name: 'sa-carbon',
  override: {
    KC_ESC: 'accent',
    KC_ENT: 'accent',
    KC_F5: 'accent',
    KC_F6: 'accent',
    KC_F7: 'accent',
    KC_F8: 'accent',
    KC_PSCR: 'accent',
    KC_SLCK: 'accent',
    KC_PAUS: 'accent',
    KC_UP: 'accent',
    KC_LEFT: 'accent',
    KC_DOWN: 'accent',
    KC_RGHT: 'accent'
  }
};
